export default {
  mail_templates: [],
  mail_template_fields: [],
  auto_mails: [],
}
